<template>
    <root-layout
        :moduleCode="moduleCode"
        :subModuleCode="subModuleCode"
        >
        <div class="bg-lilac-light ct-app-wrapper d-flex flex-column ct-header-fixed h-100"
            :class="appClass">
            <!-- begin:: Header Mobile -->

            <!-- end:: Header Mobile -->

            <!-- begin:: Root -->
            <div class="ct-root-wrapper">
                <!-- begin:: Page -->
                <div class="ct-page-wrapper" :class="{'no-header': !showHeader}">

                    <!-- begin:: Left Aside -->
                    <div v-if="hasMainSidebar" class="ct-aside ct-aside-fixed">
                        <!-- begin::Aside Brand -->
                        <div class="ct-aside-brand" id="ct_aside_brand">
                            <div class="ct-aside-brand-logo">
                                <router-link :to="{ name: initialPagePlatform }" class="">
                                    <img :src="assetsPathGlobalPlatform('/logo-1.svg')" width="138px" alt="">
                                </router-link>
                            </div>
                        </div>
                        <!-- end:: Aside Brand -->
                        <!-- begin:: Aside Menu -->
                        <div class="ct-aside-menu-wrapper" id="ct_aside_menu_wrapper">
                            <div class="ct-aside-menu">
                                <slot name="aside-main-menu"></slot>
                            </div>
                        </div>
                    </div>
                    <!-- this overlay is activated only when mobile menu is triggered -->
                    <div v-if="hasMainSidebar"
                        class="ct-aside-overlay"
                        data-action="toggle"
                        data-class="mobile-nav-on"
                        @click.prevent="sidebarStatus=false"></div>
                    <!-- end:: Left Aside -->

                    <!-- begin:: Content Wrapper -->
                    <div class="ct-content-wrapper">
                        <!-- begin:: Page Header -->
                        <header-nav
                            v-if="showHeader"
                            :moduleCode="moduleCode"
                            :hasNavTopMenu="hasNavTopMenu"
                            :hasMainSidebarSlot="hasMainSidebar"
                            :activeSearchPortal="activeSearchPortal"
                            :showBorderTopLeft="hasMainSidebar && !mainSidebarOnlyMobile"
                            @toggleClick="toggleSideBar">
                        </header-nav>

                        <top-menu-dashboard
                            :moduleCode="moduleCode"
                            @toggleClick="toggleSideBar"
                            :isStatic="staticTopMenuDashboard"
                            :isFixed="fixedTopMenuDashboard"
                            v-if="hasNavTopMenu && !(hasMainSidebar && !mainSidebarOnlyMobile)">
                        </top-menu-dashboard>
                        <!-- end:: Page Header -->


                        <!-- begin:: Page Content -->
                        <div class="ct-content">
                            <!-- begin:: Content -->
                            <div class="ct-container container-fluid " :class="[moduleCode, containerClasses]">
                                <!-- begin:: Breadcrumb -->
                                <slot name="breadcrumb"></slot>
                                <!-- begin:: Content Top -->
                                <slot name="content-top"></slot>
                                <!-- end:: Breadcrumb -->
                                <slot name="main"></slot>

                                <!-- begin:: Common Overlay -->
                                <template v-if="hasSidebarControlSlot">
                                    <slot name="aside-control"></slot>
                                </template>
                                <!-- <div v-if="hasSidebarControlSlot" class="ct-content-dialog" role="dialog" aria-hidden="true">
                                    <slot name="aside-control"></slot>
                                </div> -->

                                <!-- end:: Util Modals -->
                                <modal-confirmation ref="modalConfirmation"></modal-confirmation>
                                <modal-prompt ref="modalPrompt"></modal-prompt>
                                <modal-export ref="modalExport"></modal-export>
                                <modal-info ref="modalInfo"></modal-info>
                            </div>
                            <!-- end:: Content -->
                        </div>
                        <!-- end:: Page Content -->

                        <!-- begin:: Footer -->
                        <slot v-if="showFooter" name="footer"></slot>
                        <!-- end:: Footer -->

                        <!-- begin:: Common Overlay -->
                        <!-- <div v-if="hasSidebarControlSlot" class="ct-content-dialog" role="dialog" aria-hidden="true">
                            <slot name="aside-control"></slot>
                        </div> -->
                        <!--
                            TODO FINALIZAR O MENU COM OS ITENS SUBMENU
                            <slot name="bottom-control"></slot>
                        -->


                        <!-- end:: Control Sidebar -->

                    </div>
                    <!-- end:: Content Wrapper -->
                </div>
                <!-- end:: Page -->

            </div>
            <!-- end:: Root -->
        </div>
    </root-layout>
</template>

<script>

    import GlobalMixin from '@/app/shared/mixins/global';
    import { AppHeaderNav, AppTopMenuDashboard } from '@/app/shared/components';

    export default  {
        mixins: [
            GlobalMixin,
        ],
        props: {
            moduleCode: {
                type: String,
                require: true,
                default: null
            },
            subModuleCode: {
                type: String,
                require: false,
                default: null
            },
            containerClasses: {
                type: String,
                default: null
            },
            enableHeader: {
                type: Boolean,
                default: true
            },
            enableFooter: {
                type: Boolean,
                default: true
            },
            enableMainSidebar: {
                type: Boolean,
                default: true
            },
            mainSidebarOnlyMobile: {
                type: Boolean,
                default: false
            },
            navTopMenu: {
                type: Boolean,
                default: true
            },
            fixedTopMenuDashboard: {
                type: Boolean,
                default: false
            },
            staticTopMenuDashboard: {
                type: Boolean,
                default: false
            },
            activeSearchPortal: {
                type: Boolean,
                default: false
            }
        },
        components: {
            HeaderNav: AppHeaderNav,
            TopMenuDashboard: AppTopMenuDashboard,
            ModalConfirmation: () => import(/* webpackChunkName: "modal-confirmation" */ '@/app/shared/components/modals/ModalConfirmation'),
            ModalPrompt: () => import(/* webpackChunkName: "modal-prompt" */ '@/app/shared/components/modals/ModalPrompt'),
            ModalExport: () => import(/* webpackChunkName: "modal-export" */ '@/app/shared/components/modals/ModalExport'),
            ModalInfo: () => import(/* webpackChunkName: "modal-info" */ '@/app/shared/components/modals/ModalInfo'),
            modal: () => import(/* webpackChunkName: "modal" */ '@/app/shared/components/modals/Modal'),
        },
        data () {
            return {
                sidebarStatus: false,
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.$root.$on('openConfirmation', ({id, data, text, callback, title, cancel}) => {
                    if(this.$refs.modalConfirmation){
                        this.$refs.modalConfirmation.open(
                            callback,
                            id,
                            null,
                            text,
                            data,
                            title,
                            cancel,
                        );
                    }
                });
                this.$root.$on('openPrompt', ({id, data, text, callback, title}) => {
                    if(this.$refs.modalPrompt){
                        this.$refs.modalPrompt.open(
                            callback,
                            id,
                            text,
                            data,
                            title,
                        );
                    }
                });
                this.$root.$on('openExport', (params) => {
                    if(this.$refs.modalExport){
                        this.$refs.modalExport.open(params);
                    }
                });
                this.$root.$on('openInfo', (params) => {
                    if(this.$refs.modalInfo){
                        this.$refs.modalInfo.open(params);
                    }
                });
            });
        },
        computed: {
            appClass() {
                return {
                    'ct-aside-on': this.sidebarStatus,
                    'ct-topmenu-on': this.topMenuStatus,
                    'ct-aside-enabled ct-aside-fixed': this.hasMainSidebar,
                    'ct-aside-only-mobile': this.mainSidebarOnlyMobile
                }
            },
            hasMainSidebarSlot() {
                return !!this.$slots['aside-main-menu']
            },
            hasSidebarControlSlot() {
                return !!this.$slots['aside-control']
            },
            hasMainSidebar() {
                return this.enableMainSidebar && this.hasMainSidebarSlot;
            },
            hasNavTopMenu() {
                return this.navTopMenu && this.layoutConf.navigation.navTopMenu;
            },
            showHeader() {
                return this.enableHeader && !this.$route.meta.hideHeader;
            },
            showFooter() {
                return this.enableFooter && this.layoutConf.navigation.footer;
            },
        },
        methods:
        {
            toggleSideBar() {
                this.sidebarStatus = !this.sidebarStatus;
            },
            agreeTerms: function()
            {
                this.$root.$helper.cookie.setCookie("agreeTerms", true, 365);
                $('.modal-terms').modal('hide')  ;
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "@styles/_colors.scss";
@import '@styles/_theme.scss';

.ct-root-wrapper {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;

    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;

    -webkit-box-flex: 1;
    flex: 1;
    -ms-flex: 1 0 0px;

    .ct-page-wrapper {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;

        -webkit-box-flex: 1;
        -ms-flex: 1 0 auto;
        flex: 1 0 auto;

        .ct-content-wrapper {
            position: relative;

            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;

            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;

            -webkit-box-flex: 1;
            flex: 1 auto;
            -ms-flex: 1 0 0px;
            min-width: 0;

            overflow:hidden;

            @media (min-width: 1025px) {
                .content-wrapper {
                    -webkit-transition: all 0.3s ease;
                    transition: all 0.3s ease;

                    padding-left: $navbar-sidebar-width;
                }
            }

            .ct-content {
                /* these are the flex items */
                -webkit-box-flex: 1;
                -webkit-flex: 1;
                -moz-box-flex: 1;
                -ms-flex: 1;
                flex: 1;

                .ct-container {
                    &.nav-sidebar-container {
                        height: 100%;
                        position: relative;
                    }

                    &:not(.nav-sidebar-container) {
                        padding-bottom: 15px;
                    }

                    &.only-map {
                        padding: 0 !important;
                        height: 100%;
                        position: relative;
                    }
                }
            }

            .ct-offcanvas-panel {
                z-index: $zindex-content-overlay;
                position: absolute;
                -webkit-overflow-scrolling: touch;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                overflow-y: auto;
                backface-visibility: hidden;
                -webkit-backface-visibility: hidden;
                -webkit-transition: left 0.3s ease, right 0.3s ease;
                transition: left 0.3s ease, right 0.3s ease;

            }


            // .ct-aside-control {
            //     position: fixed;
            //     top: $navbar-header-height;
            //     bottom: 0;
            //     z-index: $zindex-control-sidebar;
            //     width: $navbar-sidebar-control-width;
            //     float: none;
            //     height: 100vh;

            //     .control-sidebar-slide-open {
            //         right: 0;
            //         transition: right .3s ease-in-out,display .3s ease-in-out;
            //     }
            //     &.ct-aside-control-light {
            //         background: #ffffff;
            //     }
            // }

            .ct-content-dialog {
                z-index: $zindex-content-sidebar;
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                width: auto;
            }
        }

        .ct-aside {
            width: $navbar-sidebar-width;
            -webkit-transition: all 0.3s ease;
            transition: all 0.3s ease;
            background-color: $side-menu-bg-color;

            // @if($theme-name != 'default') {
            //     background-color: $background-color;
            //     background-image: -webkit-gradient(linear, left top, right top, from($gradient-secondary-color), to($gradient-primary-color));
            //     background-image: -webkit-linear-gradient(172deg, $gradient-secondary-color 27%, $gradient-primary-color 98%);
            //     background-image: -moz-linear-gradient(172deg, $gradient-secondary-color 27%, $gradient-primary-color 98%);
            //     background-image: -o-linear-gradient(172deg, $gradient-secondary-color 27%, $gradient-primary-color 98%);
            //     background-image: -ms-linear-gradient(172deg, $gradient-secondary-color 27%, $gradient-primary-color 98%);
            //     filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#{$gradient-secondary-color}', endColorstr='#{$gradient-primary-color}',GradientType=1 );
            //     -ms-filter: "progid:DXImageTransform.Microsoft.gradient (GradientType=0, startColorstr=#{$gradient-secondary-color}, endColorstr=#{$gradient-primary-color})";
            //     background-image: linear-gradient(172deg, $gradient-secondary-color 27%, $gradient-primary-color 98%);
            // }

            .ct-aside-brand {
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-pack: justify;
                -ms-flex-pack: justify;
                justify-content: center;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                -webkit-box-orient: horizontal;
                -webkit-box-direction: normal;
                -ms-flex-direction: row;
                flex-direction: row;
                padding: 2.25rem 1.5rem;
            }

            .ct-aside-menu {
                margin: 1rem 0;
                position: relative;
                overflow: hidden !important;
                overflow-anchor: none;
                -ms-overflow-style: none;
                touch-action: auto;
                -ms-touch-action: auto;
            }

            &.ct-aside-fixed {
                webkit-overflow-scrolling: touch;
                overflow-y: auto;
                -webkit-transform: translate3d(0, 0, 0);
                backface-visibility: hidden;
                -webkit-backface-visibility: hidden;
                // width: 275px !important;

                position: fixed;
                top: 0;
                bottom: 0;
            }
        }
    }
}

.ct-header-fixed {
    .ct-page-wrapper {
        padding-top: 0; //$navbar-header-height;
        @include sm {
            &:not(.no-header) {
                padding-top: $navbar-header-height-sm;
            }
        }
    }
}

@media print {
    .ct-header-fixed {
        .ct-page-wrapper {
            padding-top: 0 !important;

            .ct-header {
                display: none !important;
            }
        }
    }
}

@media (max-width: 1024px){
    .ct-aside-fixed {
        .ct-aside {
            z-index: $zindex-main-sidebar;
            left: -$navbar-sidebar-width;
        }
    }
    .ct-aside-on {
        .ct-aside {
            -webkit-transition: left 0.3s ease, right 0.3s ease;
            transition: left 0.3s ease, right 0.3s ease;
            left: 0;
        }
        .ct-aside-overlay {
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            overflow: hidden;
            z-index: $zindex-main-sidebar - 1;
            background: rgba(0, 0, 0, 0.1);
            -webkit-animation: kt-animate-fade-in .3s linear 1;
            animation: kt-animate-fade-in .3s linear 1;
        }
    }
}

@media (min-width: 1025px) {
    .ct-aside-fixed {
        &.ct-aside-only-mobile {
            .ct-aside {
                z-index: $zindex-main-sidebar;
                left: -$navbar-sidebar-width;
            }
        }

        &:not(.ct-aside-only-mobile) {
            .ct-aside {
                left: 0;
                z-index: $zindex-main-sidebar;
            }
            .ct-content-wrapper {
                padding-left: $navbar-sidebar-width;
            }
        }
    }

    .ct-container {
        &:not(.nav-sidebar-container) {
            padding: 1.5rem 1.5rem 1.5rem;
        }
    }
}

</style>

<style lang="scss" >
@import "@styles/_mixins.scss";
@import '@styles/_theme.scss';
.ct-content {
    .ct-container {
        .content-title {
            margin-top: 15px;
            margin-bottom: 0.5rem;

            @include sm {
                // margin-top: 0;
            }
        }
    }
}
// .ct-content-dialog {
//     > div:not(.ct-aside-control) {
//         position: relative;
//         height: 100%;
//         width: auto;
//     }
// }
.ct-root-wrapper {
    .ct-page-wrapper {
        .ct-content-wrapper {
            .ct-content {
                .ct-container {
                    > .ct-aside-control {
                        z-index: $zindex-content-sidebar;
                    }
                }
            }
        }
    }
}
</style>